import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getOptedCampaignsDetailsByInfluencer = (payload, callback) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_REQUEST,
    payload,
    callback
});

// Action creator for successful OTP generation
export const getOptedCampaignsDetailsByInfluencerSuccess = (payload) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getOptedCampaignsDetailsByInfluencerFailure = (payload) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getOptedCampaignsDetailsByInfluencerReset = () => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getOptedCampaignsDetailsByInfluencerResetAll = () => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET_ALL,
});
